import React from 'react'
import { tokens } from '../../styles/tokens'
import { newThemeObject } from '../../newTheme'
import { ActiveOrdersTile, useSegmentTrackStyles } from './ActiveOrdersTile'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { Pages } from '../../router/router'
import { sortOrderTable } from '../../redux/actions/filterActions'
import { OrdersByStateOptions } from '../../redux/reducers/filters'
import {
  ORDER_STATE_CANCELED,
  ORDER_STATE_CONFIRMED,
  ORDER_STATE_ERROR,
  ORDER_STATE_EXPIRED,
  ORDER_STATE_FILLED,
  ORDER_STATE_NEW,
  ORDER_STATE_PARTIAL_CANCELED,
  ORDER_STATE_PARTIAL_EXPIRED,
  ORDER_STATE_PARTIAL_FILLED,
  ORDER_STATE_REJECTED,
} from '../../constants/codeLists'
import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { OrdersByStateCount } from '../../redux/reducers/orders'
import { useOrderFiltersDates } from '../../hooks/useOrderFilters'
import { useSelector } from '../../redux/hooks/useSelector'

interface ActiveOrdersProps {
  ordersByStateCount: OrdersByStateCount[]
}

export const ActiveOrdersTiles: React.FC<ActiveOrdersProps> = ({ ordersByStateCount }) => {
  const trackClasses = useSegmentTrackStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { clientId } = useParams<{ clientId: string }>()
  const { t } = useTranslation()
  const orders = useOrderFiltersDates()
  const filters = useSelector(state => state.filters)

  const onStateClick = (countState: OrdersByStateOptions) => () => {
    if (clientId === null || clientId === undefined) history.push(Pages.OrderList)

    dispatch(sortOrderTable(countState))
  }

  const countBy = (predicate: (state: string) => boolean) =>
    orders && orders.length > 0 ? orders.filter(item => predicate(item.state)).length : '?'

  const segments = [
    {
      label: t('ALL'),
      count: orders && orders.length > 0 ? orders.length : '?',
      option: OrdersByStateOptions.All,
      dot: undefined as string | undefined,
    },
    {
      label: t('REJECTED'),
      count: countBy(s => s === ORDER_STATE_REJECTED),
      option: OrdersByStateOptions.Rejected,
      dot: tokens.color.error[500],
    },
    {
      label: t('OPEN'),
      count: countBy(s => s === ORDER_STATE_CONFIRMED),
      option: OrdersByStateOptions.Open,
      dot: newThemeObject.palette.state.confirmed,
    },
    {
      label: t('PARTIAL'),
      count: countBy(s => s === ORDER_STATE_PARTIAL_FILLED),
      option: OrdersByStateOptions.Partial,
      dot: tokens.color.warning[500],
    },
    {
      label: t('CLOSED'),
      count: countBy(
        s =>
          s === ORDER_STATE_FILLED ||
          s === ORDER_STATE_CANCELED ||
          s === ORDER_STATE_PARTIAL_EXPIRED ||
          s === ORDER_STATE_PARTIAL_CANCELED ||
          s === ORDER_STATE_EXPIRED ||
          s === ORDER_STATE_ERROR
      ),
      option: OrdersByStateOptions.Closed,
      dot: tokens.color.success[500],
    },
    {
      label: t('UNSENT'),
      count: countBy(s => s === ORDER_STATE_NEW),
      option: OrdersByStateOptions.New,
      dot: tokens.color.primary[300],
    },
  ]

  return (
    <div className={trackClasses.track}>
      {segments.map(segment => (
        <ActiveOrdersTile
          key={segment.option}
          label={segment.label}
          count={segment.count}
          dot={segment.dot}
          selected={filters.sortOrdersBy === segment.option}
          onClick={onStateClick(segment.option)}
        />
      ))}
    </div>
  )
}
